import { makeMinionCard } from '../../cards/make-minion';

export const GruntCard = makeMinionCard({
    name: 'Grunt',
    power: 6,
    goldCost: 1
});